import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import Button from "../button/button";
import CreateAccountModal from "../../pages/signup/signup";
import LoginModal from "../../pages/login/login";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../Modal/Modal";
import { successToast } from "../../utils/notificationUtils";
import SidebarContext from "../../contexts/MyContext";
import SettingHandler from "../../Apihander/setting/settingHandler";
import { Icon } from "@iconify/react";
import getStripe from "../../utils/getStripe";
import { useForm } from "react-hook-form";
import { errorToast } from "../../utils/notificationUtils";
import { OTPInput } from '../../components/OTPInput/OTPInput'
import SignUpHandler from "../../Apihander/signup/signupHandler";
import LogOutHandler from "../../Apihander/logOut/logoutHandler";
import { detectBrowser } from "../../utils/detectbrowser";
import ForgotPassword from "../../pages/forgotPassword/forgotPassword";
import { usePremiumStatus } from "../../hooks/usePremiumStatus";
import { formatEmailAsName, truncateFileName } from "../../utils/truncateFileName";
import { Tooltip } from "react-tooltip";
import { useMakePayment } from "../../hooks/useMakePayment";
import { isTablet, isDesktop } from "react-device-detect";
import { generateRandomNumber } from "../../utils/generateRandomNumber";
import { isMobile } from 'react-device-detect';
const { detect } = require('detect-browser');



const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname
    const detectbrowser = detect();
    // Brave detection logic
    let detectDeviceName = detectbrowser?.name || "unknown";

    // Check for Brave specifics
    if (detectbrowser?.name === 'chrome') {
        // Additional checks for Brave
        if (navigator.brave || window.navigator.userAgent.includes('Brave')) {
            detectDeviceName = 'brave';
        }
    }

 
    const { startPolling } = usePremiumStatus();
    const { user, setUser, selectedFormat, setSelectedFormat, selectedQuality, setSelectedQuality, openForgotPasswordModal, setOpenForgotPasswordModal, openOtpModal,
        setOpenOtpModal, storeOtpUser, setStoreOtpUser, storeUser, isPremium, setIsPremium, premiumLoading, setPremiumLoading, setIsPolling, isAnnual, setPremiumStatus, widgetLoaded,
        setWidgetLoaded, isRecording, setIsRecording, resetRecording, setActionTabIndex, setTabIndex, sectionRef, isSubscriptionActive, handleSaveAudioRecording, setIsLoginCancel, btntoggl, setBtnToggl, setRecordingStart, recordingStart, alertModal, setAlertModal,
        audioBlobUrl,
        stopRecording,
        eventClick, setEventClick,
        setElapsedTime
    } = useContext(SidebarContext);
    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();
    const { handleMakePaymentOfPremium } = useMakePayment();
    const [clearOtp, setClearOtp] = useState(false);
    const [signUpModalOpen, setSignUpModalOpen] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [otpValue, setOtpValue] = useState('');
    const [error, setError] = useState(null);
    const dropdownRef = useRef(null);
    const dropdownRefQuality = useRef(null)
    const [countdown, setCountdown] = useState(59);
    let countdownTimer = null;
    const [load, setLoad] = useState(false)
    const [registerUserEmail, setRegisterUserEmail] = useState('')
    // const [widgetLoaded, setWidgetLoaded] = useState(false);
    const freshdeskButtonRef = useRef(null);
    const hasFetchedSettings = useRef(false);
    const widgetInitialized = useRef(false);



    const scrollToFeaturesSection = () => {
        const featuresSection = document.getElementById("features-section");
        // if (featuresSection) {
        //     featuresSection.scrollIntoView({ behavior: "smooth" });
        // }
        if (featuresSection) {
            const offset = 80; // Adjust this value based on your navbar height
            const elementPosition = featuresSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    const scrollToTopOfHomeSection = () => {
        const topOfHomeSection = document.getElementById("hero-section");

        if (topOfHomeSection) {
            const offset = 120; // Adjust this value based on your navbar height
            const elementPosition = topOfHomeSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    const handleFeaturesClick = () => {
        // Redirect to the home page
        navigate("/");
        // Scroll to the features section
        scrollToFeaturesSection();
    };


    const signUpOpenModal = () => {
        setSignUpModalOpen(true);
    };

    const signUpCloseModal = () => {
        setSignUpModalOpen(false);
    };

    const loginOpenModal = () => {
        setLoginModalOpen(true);
    };

    const loginCloseModal = () => {
        setLoginModalOpen(false);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const getSetting = async () => {
        try {
            const data = await SettingHandler.doGetSetting();

            if (data.status) {
                setSelectedFormat(data?.data?.audioFormat);
                setSelectedQuality(data?.data?.audioQuality);

                const updatedUser = {
                    ...user,
                    audioFormat: data?.data?.audioFormat,
                    audioQuality: data?.data?.audioQuality,
                };

                localStorage.setItem("currentUser", JSON.stringify(updatedUser));

                if (data?.data?.audioFormat == "caf" || data?.data?.audioFormat == "m4a") {
                    setSelectedFormat("mp3");
                }

                // Update user if necessary
                if (JSON.stringify(user) !== JSON.stringify(updatedUser)) {
                    setUser(updatedUser);
                }
            }
        } catch (error) {
            console.log("🚀 ~ getSetting ~ error:", error);
        }
    };


    const handleFormatChange = useCallback(async (value, event) => {
        event.stopPropagation(); // Prevent dropdown from closing
        setSelectedFormat(value)
        try {
            const payload = {
                audioFormat: value
            }
            await SettingHandler.doHandlerSetting(payload)
        } catch (error) {
            console.log("🚀 ~ handleFormatChange ~ error:", error)

        }
    }, []);

    // const handleQualityChange = useCallback((value, event) => {
    //     event.stopPropagation(); // Prevent dropdown from closing
    //     setSelectedQuality(value);

    // });


    const handleQualityChange = useCallback(async (value, event) => {
        event.stopPropagation();
        setSelectedQuality(value)
        try {
            const payload = {
                audioQuality: value
            }
            await SettingHandler.doHandlerSetting(payload)
        } catch (error) {
            console.log("🚀 ~ handleFormatChange ~ error:", error)

        }
    }, []);


    const handleUpdateDeviceType = async () => {
        try {
            const payload = {
                deviceType: detectbrowser.type
            }
            await SettingHandler.doHandlerSetting(payload)
        } catch (error) {
            console.log("🚀 ~ handledeviceType ~ error:", error)

        }
    }

    const handleLogOut = async (e) => {
        e.preventDefault()
        try {
            const payload = {
                deviceType: detectbrowser.type,
                deviceName: detectDeviceName
            }
            const response = await LogOutHandler.doHandelLogOut(payload)
            // console.log(response,'response')
            if (response?.status === 200 || response?.data?.statusCode === 200) {
                navigate("/");
                setUser(null);
                setPremiumStatus(null)
                setActionTabIndex(null)
                setTabIndex()
                // setBtnToggl(false)

                setBtnToggl(false)
                setIsLoginCancel(true)
                setRecordingStart(false)

                window.location.reload()


            }


        } catch (error) {
            console.log("🚀 ~ getSetting ~ error:", error)

        }
    };



    useEffect(() => {
        if (user && !hasFetchedSettings.current) {
            hasFetchedSettings.current = true; // Mark as fetched
            getSetting();
            handleUpdateDeviceType();
        }
    }, [user]);

    const handleCheckout = async () => {
        const stripe = await getStripe();
        const { error } = await stripe.redirectToCheckout({
            lineItems: [
                {
                    price: process.env.REACT_APP_PUBLIC_STRIPE_PRICE_ID,
                    quantity: 1,
                },
            ],
            mode: 'subscription',
            successUrl: `http://localhost:3000/success`,
            cancelUrl: `http://localhost:3000/cancel`,
            customerEmail: 'customer@email.com',
        });
        console.warn(error.message);
    }

    const onsubmit = async (payload) => {
        // console.log(payload, 'changepassword payload')
        try {
            setLoading(true)

            const data = await SettingHandler.doHandlerChangePassword(payload)
            if (data.statusCode === 200) {
                successToast(data?.message)
                navigate('/')
                setLoading(false)
                setOpenChangePasswordModal(false)
                reset()
            } else {
                const errorMessage =
                    data?.response?.data?.message || data.message || "An error occurred";
                errorToast(errorMessage)
                setLoading(false)
            }

        } catch (error) {
            console.log('Error on Contact :', error)
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            errorToast(errorMessage);
            setLoading(false)

        }
    }



    const handleOtpSubmit = async () => {
        setLoading(true);
        setError(null);
        const payload = {
            'email': registerUserEmail,
            'otp': otpValue
        }
        try {
            const data = await SignUpHandler.doHandlerOtpSubmit(payload)
            // console.log(data)
            if (data?.statusCode === 200) {
                // successToast(data?.message)
                setOtpValue('')
                setClearOtp(true); // Set clearOtp to true to reset the input
                setOpenOtpModal(false)
                storeUser(storeOtpUser);
                setLoading(false)
                // setError('')
                console.log(isPremium, 'isPremium')
                if (isPremium && !user) {
                    await handleMakePaymentOfPremium()
                } else {
                    navigate('/dashboard')
                }
            } else {
                // console.error('OTP verification failed:', data.message);
                const errorMessage = data?.response?.data?.message || data?.message || "An error occurred";
                // setError(errorMessage);
                errorToast(errorMessage);
                setLoading(false)
            }
        } catch (err) {
            setLoading(false);
            // setError('An error occurred while verifying the OTP.');
            console.error('Error:', err);
        }
    };


    // PHP

    // const handleEncriptionsOfData = async () => {
    //     setPremiumLoading(true)
    //     try {
    //         const payload = {
    //             "payment_method_id": "6",
    //             "customer_payment_id": "",
    //             "project_code": "1139.2",
    //             "email": "denju.b@upsquare.in",
    //             "plan_id": "plan_Mvt5eO6GUlUu0A",
    //             "success_url": `https://1302-1-voicerec-web.vercel.app/redirect?status=success`,
    //             "cancel_url": `https://1302-1-voicerec-web.vercel.app/redirect?status=cancel`,
    //             "interval": "day",
    //             "subscription_type": "RECURRING"
    //         }

    //         const data = await SignUpHandler.doEncriptions(payload)
    //         // console.log(data, 'data of encriptions')
    //         if (data) {
    //             await handleMakePayment(data)
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         setPremiumLoading(false)


    //     }
    // }


    // const handleMakePayment = async (encryptionData) => {
    //     // console.log(encryptionData, 'data at time ofmake payment')
    //     try {
    //         const data = await SignUpHandler.doMakePayment(encryptionData)
    //         // console.log(data, 'data of payment')
    //         if (data) {
    //             await handledecryptionOfData(data)
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         setPremiumLoading(false)


    //     }
    // }

    // const handledecryptionOfData = async (decryptionData) => {
    //     // console.log(decryptionData, "data at time of decryption");
    //     try {
    //         const data = await SignUpHandler.doDecryptions(decryptionData);
    //         console.log(data, "decripted data after payment")
    //         setPremiumLoading(false)
    //         const url = data?.data?.url;


    //         if (url) {
    //             window.open(url, "_blank");
    //         }
    //     } catch (error) {
    //         console.error('Error', error)
    //         setPremiumLoading(false)

    //     }
    // }

    const handleResendOtp = async () => {
        setLoad(true)
        try {
            const data = await SignUpHandler.doHandlerResendOtpSubmit()
            if (data.statusCode === 200) {
                // Handle successful OTP verification, e.g., close the modal or navigate
                startCountdown(); // Restart the countdown timer when OTP is resent successfully
                setClearOtp(false); // Temporarily set to false to force reset
                setTimeout(() => {
                    setClearOtp(true); // Set back to true to clear the input
                }, 0);
                successToast(data?.message)
                setLoad(false)
                // setError('')
            } else {
                const errorMessage = data?.response?.data?.message || data?.message || "An error occurred";
                errorToast(errorMessage);
                setLoad(false)
                // setError(errorMessage);

            }
        } catch (err) {
            setLoading(false);
            // setError('An error occurred while verifying the OTP.');
            console.error('Error:', err);
            setLoad(false)

        }
    }


    // Function to start the countdown
    const startCountdown = () => {
        setCountdown(59); // Reset the countdown to 59 seconds
        setOtpValue('')
        setClearOtp(true); // Set clearOtp to true to reset the input

    };

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev === 1) {
                        clearInterval(timer); // Stop the timer when reaching 0
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        // Cleanup timer when the component unmounts or countdown changes
        return () => clearInterval(timer);
    }, [countdown]);

    // Start the countdown when the modal opens
    useEffect(() => {
        if (openOtpModal) {
            const getRegisterUserEmail = localStorage.getItem('RegisterEmail')
            // console.log(getRegisterUserEmail)
            setRegisterUserEmail(getRegisterUserEmail)
            startCountdown();
        }
    }, [openOtpModal]);



    // useEffect(() => {
    //     if (user) {
    //         // Load Freshworks Widget script
    //         window.fwSettings = {
    //             'widget_id': 81000001805,
    //         };

    //         const script = document.createElement('script');
    //         script.src = 'https://ind-widget.freshworks.com/widgets/81000001805.js';
    //         script.async = true;
    //         script.defer = true;

    //         script.onload = () => {
    //             setWidgetLoaded(true);
    //             const checkIframe = setInterval(() => {
    //                 const freshdeskButton = document.querySelector('iframe.fw-support-icon');
    //                 if (freshdeskButton) {
    //                     freshdeskButtonRef.current = freshdeskButton; // Track the button in the ref
    //                     freshdeskButton.style.position = 'fixed';
    //                     freshdeskButton.style.bottom = '20px';
    //                     freshdeskButton.style.right = '20px';
    //                     freshdeskButton.style.zIndex = '9999';
    //                     clearInterval(checkIframe); // Stop checking once styled
    //                 }
    //             }, 100);
    //         };

    //         document.body.appendChild(script);
    //         return () => {
    //             if (freshdeskButtonRef.current) {
    //                 freshdeskButtonRef.current.remove(); // Remove the Freshdesk button when user logs out
    //                 freshdeskButtonRef.current = null; // Reset the ref
    //             }
    //             document.body.removeChild(script); // Remove the script
    //             setWidgetLoaded(false); // Mark widget as unloaded
    //         };
    //     } else {
    //         if (freshdeskButtonRef.current) {
    //             freshdeskButtonRef.current.remove(); // Ensure the button is removed
    //             freshdeskButtonRef.current = null; // Reset the ref
    //         }
    //         setWidgetLoaded(false); // Reset widget loaded state
    //     }
    // }, [user]);



    useEffect(() => {
        // Checked against the page, since a re-run while the script downloads would add a second launcher.
        if (user && !document.querySelector('script[src*="widgets/81000001805.js"]')) {
            widgetInitialized.current = true;
            window.fwSettings = {
                widget_id: 81000001805,
            };

            const script = document.createElement('script');
            script.src = 'https://ind-widget.freshworks.com/widgets/81000001805.js';
            script.async = true;
            script.defer = true;

            script.onload = () => {
                setWidgetLoaded(true);
                const checkIframe = setInterval(() => {
                    // The visible Support button is Freshworks' launcher iframe.
                    const freshdeskButton = document.querySelector('iframe.fw-support-icon, #launcher-frame');
                    if (freshdeskButton) {
                        freshdeskButtonRef.current = freshdeskButton; // Track the button in the ref
                        freshdeskButton.style.position = 'fixed';
                        // Sits low so it clears the recording tool bar.
                        freshdeskButton.style.bottom = '4px';
                        freshdeskButton.style.right = '20px';
                        freshdeskButton.style.zIndex = '9999';
                        freshdeskButton.style.fontFamily = 'Metropolis';
                        clearInterval(checkIframe);
                    }
                }, 100);
            };

            document.body.appendChild(script);
        }

        return () => {
            if (!user && widgetInitialized.current) {
                if (freshdeskButtonRef.current) {
                    freshdeskButtonRef.current.remove();
                    freshdeskButtonRef.current = null;
                }
                widgetInitialized.current = false;
                setWidgetLoaded(false);

            }
        };
    }, [user]);



    const scrollToSection = () => {
        navigate('/');

        // Use a timeout to allow navigation to complete before scrolling
        setTimeout(() => {
            const element = sectionRef.current;

            if (element) {
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

                const customOffsetHeight = 175;

                window.scrollTo({
                    top: elementPosition - customOffsetHeight,
                    behavior: 'smooth',
                });
            }
        }, 100);
    };

    const handleDownloadClick = async (e) => {
        // Generate a random audio file name (you can change the format if needed)
        const randomAudioName = `Voice${generateRandomNumber()}.mp3`;

        if (audioBlobUrl && randomAudioName) {
            try {
                // Create an anchor element and trigger the download
                const link = document.createElement('a');
                link.href = audioBlobUrl; // Use the blob URL directly
                link.download = randomAudioName; // Set the file name for download

                // Append the link to the body, trigger click, then remove the link
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error downloading the audio file:", error);
            }
        } else {
            console.error("Audio URL or filename is missing!");
        }
    };


    return (
        <>
            <div className="site-header">
                <div
                    className={path == "/dashboard" ? "container-fluid" : "container"}
                >
                    <div className="vr-header-inner" style={{ padding: "28px 0px 20px 0px" }}>
                        <nav
                            className="navbar navbar-expand-lg navbar-light"
                            style={{ padding: "0" }}
                        >
                            {
                                location.pathname == "/pricing" && user ?

                                    (
                                        <>
                                            <a
                                                className="navbar-brand"
                                                onClick={() => {
                                                    const previousLocation = location.state?.from;
                                                    if (previousLocation) {
                                                        navigate(previousLocation);
                                                    } else {
                                                        navigate(-1);
                                                    }
                                                    setPremiumStatus(null)
                                                    setIsPolling(false);
                                                }}
                                                style={{ cursor: "pointer", display: 'flex', alignItems: 'center' }}
                                            >
                                                <button
                                                    type="button"
                                                    className="close"
                                                    style={{
                                                        width: "35px",
                                                        borderRadius: "50%", height: "35px",
                                                        // background: "#F1F5F9",
                                                        border: "none",
                                                        // color: "#94A3B8",
                                                        color: '#000000',
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: 'center',
                                                        // background: "#F1F5F9",
                                                        background: 'white',
                                                        // color: "#94A3B8",
                                                        cursor: "pointer",

                                                    }}


                                                >
                                                    <span aria-hidden="true" style={{
                                                        fontSize: "30px", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%",
                                                        paddingBottom: "2px"
                                                    }}>&times;</span>
                                                </button>
                                                {/* <img src="/img/logo1.png" height="44px" width="44px" style={{ borderRadius: '50%' }} /> */}
                                                <span className="vr-close-label" style={{
                                                    fontFamily: 'Metropolis',
                                                    fontWeight: '600',
                                                    fontSize: '16px',
                                                    color: "#0F172A",
                                                }}>
                                                    Close
                                                </span>
                                            </a>

                                        </>
                                    ) : (
                                        <div>
                                            <a
                                                className="navbar-brand"
                                                onClick={() => { user && location.pathname != '/' ? navigate("/dashboard") : navigate("/"); scrollToTopOfHomeSection() }}
                                                style={{ cursor: "pointer", display: 'flex', alignItems: 'center' }}
                                            >

                                                <img src="/img/logo1.png" alt="Voice-Recorder-Mic" height="44px" width="44px" style={{ borderRadius: '50%' }} />
                                                <span className="vr-brand-word" style={{
                                                    fontFamily: 'Bebas Neue',
                                                    fontWeight: '400',
                                                    fontSize: '36px',
                                                    color: "#0F172A",
                                                    textTransform: 'uppercase',
                                                    lineHeight: 'normal',  // Adjust line height for vertical centering
                                                    marginLeft: '8px'      // Adjust margin for spacing
                                                }}>
                                                    VOICE RECORDER
                                                </span>
                                            </a>
                                        </div>)}

                            <button
                                className="navbar-toggler"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#navbarNav"
                                aria-controls="navbarNav"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div
                                className="collapse navbar-collapse justify-content-end"
                                id="navbarNav"
                            >
                                <ul className="navbar-nav align-items-center" style={{ gap: "14px" }}
                                    onClick={() => {
                                        const navbarToggler = document.getElementById("navbarNav");
                                        if (navbarToggler.classList.contains("show")) {
                                            document.getElementById("navbarNav").classList.remove("show");

                                        }
                                    }}
                                >
                                    {location.pathname == "/dashboard" ? (
                                        <>
                                            {/* <li
                                                className="nav-item active"
                                                onClick={() => {
                                                    setOpenModal(true);
                                                }}
                                            >
                                                <a
                                                    className="nav-link"
                                                    style={{
                                                        marginRight: "27px", cursor: "pointer", fontWeight: "600",
                                                        fontFamily: "Metropolis", color: "#000000", fontSize: '16px'
                                                    }}
                                                >
                                                    Settings
                                                </a>
                                            </li> */}
                                        </>
                                    ) :

                                        location.pathname == "/accountsetting" ? (
                                            <>
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link"
                                                        onClick={() => navigate("/dashboard")}
                                                        style={{
                                                            marginRight: "27px",
                                                            cursor: "pointer",
                                                            fontWeight: "600",
                                                            fontFamily: "Metropolis",
                                                            color: "#000000", fontSize: '16px'
                                                        }}
                                                    >
                                                        Dashboard
                                                    </a>
                                                </li>
                                            </>
                                        )
                                            : (
                                                <>
                                                    {/* {location.pathname == '/support' ? '' : (
                                                        <li className="nav-item active" onClick={() => handleFeaturesClick()}>
                                                            <a
                                                                className="nav-link"
                                                                style={{
                                                                    marginRight: "27px", cursor: "pointer", fontWeight: "600",
                                                                    fontFamily: "Metropolis", color: "#000000", fontSize: '16px'
                                                                }}
                                                            >
                                                                Features
                                                            </a>
                                                        </li>
                                                    )} */}

                                                    {/* <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            onClick={() => navigate("/support")}
                                                            style={{
                                                                marginRight: "27px",
                                                                cursor: "pointer",
                                                                fontWeight: "600",
                                                                fontFamily: "Metropolis",
                                                                color: "#000000", fontSize: '16px'
                                                            }}
                                                        >
                                                            Support
                                                        </a>
                                                    </li> */}
                                                    {user && (
                                                        <li className="nav-item">
                                                            <a
                                                                className="nav-link"
                                                                onClick={() => {
                                                                    if (user) {
                                                                        resetRecording();
                                                                        navigate("/dashboard");
                                                                    } else {
                                                                        signUpOpenModal();
                                                                    }
                                                                    setPremiumStatus(null)
                                                                    setIsPolling(false);
                                                                }}
                                                                style={{
                                                                    marginRight: "27px",
                                                                    cursor: "pointer",
                                                                    fontWeight: "600",
                                                                    fontFamily: "Metropolis",
                                                                    color: "#000000", fontSize: '16px'
                                                                }}
                                                            >
                                                                Go to Dashboard
                                                            </a>
                                                        </li>
                                                    )}

                                                </>
                                            )}
                                    {location.pathname !== "/pricing" && !user?.isSubscriptionActive ? (
                                        <>
                                            {/* <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    onClick={() => {
                                                        if (!user && recordingStart) {
                                                            handleSaveAudioRecording("isPricing")
                                                            setAlertModal(true)
                                                            setEventClick("isPricing")
                                                        } else {

                                                            // resetRecording()
                                                            navigate("/pricing")
                                                        }

                                                    }}
                                                    style={{
                                                        marginRight: "27px",
                                                        cursor: "pointer",
                                                        fontWeight: "600",
                                                        fontFamily: "Metropolis",
                                                        color: "#000000",
                                                        fontSize: '16px'
                                                    }}
                                                >
                                                    Pricing
                                                </a>
                                            </li> */}

                                            <li
                                                className="nav-item"
                                                style={{ marginRight: "20px" }}
                                                onClick={() => {
                                                    if (!user && recordingStart) {
                                                        handleSaveAudioRecording("isPricing")
                                                        setAlertModal(true)
                                                        setEventClick("isPricing")
                                                    } else {

                                                        // resetRecording()
                                                        navigate("/pricing")
                                                    }

                                                }}                                           >
                                                <button
                                                    className={!user ? "login-button" : "pricing-button"}
                                                >
                                                    Pricing
                                                </button>
                                            </li>
                                            {/* <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    onClick={() => {
                                                        resetRecording()
                                                        navigate("/blog")

                                                    }}
                                                    style={{
                                                        marginRight: "27px",
                                                        cursor: "pointer",
                                                        fontWeight: "600",
                                                        fontFamily: "Metropolis",
                                                        color: "#000000",
                                                        fontSize: '16px'
                                                    }}
                                                >
                                                    Blogs

                                                </a>
                                            </li> */}

                                            {/* <li className="nav-item" style={{ listStyleType: 'disc', color: "#000000" }}></li> */}
                                        </>

                                    ) : ''}
                                    {user && (user?.name || user?.email) ? 
                                    (
                                        isMobile ? (
                                        //   <div>Mobile div</div>
                                        <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            onClick={(e)=> handleLogOut(e)}
                                            style={{
                                                marginRight: "27px",
                                                cursor: "pointer",
                                                fontWeight: "600",
                                                fontFamily: "Metropolis",
                                                color: "#000000", fontSize: '16px'
                                            }}
                                        >
                                            Logout
                                        </a>
                                    </li>
                                        ) : (
                                        <>
                                            <div className="dropdown">
                                                <button
                                                    style={{
                                                        background: "transparent",
                                                        border: "none",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontWeight: "600",
                                                        fontFamily: "Metropolis",
                                                    }}
                                                    className="dropdown-toggle vr-profile-btn"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    {...(user?.name?.length > 20 || user?.email?.split('@')[0]?.length > 20
                                                        ? {
                                                            "data-tooltip-id": "icon-tooltip",
                                                            "data-tooltip-content": user?.name || user?.email?.split('@')[0],
                                                        }
                                                        : {})}
                                                >
                                                    <img src="/img/icon/user.png" alt="user" height="24" width="24" />
                                                    <span style={{ margin: '0px 7px' }}>{user.name ? truncateFileName(user?.name, 20) : formatEmailAsName(user?.email?.split('@')[0], 20)}</span>
                                                    <img
                                                        src="/img/icon/Downarrow.png"
                                                        alt="downarrow"
                                                        height="24"
                                                        width="24"
                                                    />
                                                </button>
                                                <ul
                                                    // className="dropdown-menu"
                                                    className={`dropdown-menu vr-profile-menu ${location.pathname === "/dashboard" ? "dashboard" : ""}`}
                                                    style={{
                                                        padding: "10px",
                                                        border: "1px solid #CBD5E1",
                                                        borderRadius: "10px",
                                                    }}
                                                >
                                                    <li
                                                        className=""
                                                        style={{
                                                            textAlign: "center",
                                                            borderBottom: "1px solid #F1F5F9",
                                                            padding: "10px",
                                                        }}
                                                    >
                                                        <span
                                                            className="dropdown-item"
                                                            style={{
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontFamily: "Metropolis",
                                                                fontWeight: "500",
                                                                fontSize: "14px",
                                                                color: "#64748B",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            <span
                                                                className="vr-profile-avatar"
                                                                style={{
                                                                    display: "inline-block",
                                                                    width: "44px",
                                                                    height: "44px",
                                                                    marginRight: "10px",
                                                                    backgroundImage:
                                                                        "url('/img/icon/person-circle.png')",
                                                                    backgroundSize: "contain",
                                                                    backgroundRepeat: "no-repeat",
                                                                }}
                                                            ></span>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "flex-start",

                                                                }}

                                                            >
                                                                <span
                                                                    style={{
                                                                        fontFamily: "Metropolis",
                                                                        fontWeight: "600",
                                                                        fontSize: "14px",
                                                                        lineHeight: "20px",
                                                                        letterSpacing: "-2%",
                                                                        color: "#000000",
                                                                    }}
                                                                >

                                                                    {user.name ? truncateFileName(user?.name, 20) : formatEmailAsName(user?.email?.split('@')[0], 20)}
                                                                </span>
                                                                <p
                                                                    style={{
                                                                        margin: 0,
                                                                        fontFamily: "Metropolis",
                                                                        fontWeight: "400",
                                                                        fontSize: "12px",
                                                                        lineHeight: "18px",
                                                                        color: "#64748B",
                                                                    }}
                                                                >
                                                                    {user?.email}
                                                                </p>
                                                            </div>
                                                        </span>
                                                    </li>

                                                    {/* {!user.isGoogle ? (
                                                        <li className="dropdown-custom-item" onClick={(e) => {
                                                            e.preventDefault();
                                                            setOpenChangePasswordModal(true);
                                                        }}>
                                                            <Icon icon="mdi:password-reset" className="icon" style={{ color: 'rgb(148, 163, 184)' }} />
                                                            <span
                                                                style={{
                                                                    fontFamily: "Metropolis",
                                                                    fontWeight: "500",
                                                                    fontSize: "14px",
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "-4%",
                                                                    color: "#64748B",
                                                                }}
                                                            >
                                                                {" "}
                                                                Change Password
                                                            </span>
                                                        </li>

                                                    ) :
                                                        ''
                                                    } */}

                                                    <li className="dropdown-custom-item " onClick={(e) => {
                                                        navigate("/accountsetting");
                                                        setPremiumStatus(null)
                                                        setIsPolling(false);
                                                    }}>
                                                        <img
                                                            src="/img/icon/user.png"
                                                            alt="Account Settings Icon"
                                                            className="icon"
                                                        />
                                                        <span
                                                            style={{
                                                                fontFamily: "Metropolis",
                                                                fontWeight: "500",
                                                                fontSize: "14px",
                                                                lineHeight: "20px",
                                                                letterSpacing: "-4%",
                                                                color: "#64748B",
                                                            }}
                                                        >
                                                            Account Settings
                                                        </span>
                                                    </li>
                                                    <li
                                                        className="dropdown-custom-item "
                                                        onClick={(e) => handleLogOut(e)}
                                                    >
                                                        <img
                                                            src="/img/icon/box-arrow-right.png"
                                                            alt="Logout Icon"
                                                            className="icon"
                                                        />
                                                        <span
                                                            style={{
                                                                fontFamily: "Metropolis",
                                                                fontWeight: "500",
                                                                fontSize: "14px",
                                                                lineHeight: "20px",
                                                                letterSpacing: "-4%",
                                                                color: "#64748B",
                                                            }}
                                                        >
                                                            Logout
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <Tooltip id="icon-tooltip"
                                                place="bottom"
                                                style={{
                                                    maxwidth: '400px',
                                                    whiteSpace: 'normal',
                                                    wordWrap: 'break-word',
                                                    textAlign: "left",
                                                    padding: '8px',
                                                    // fontFamily: "Metropolis, sans-serif",
                                                    fontSize: '14px',
                                                    lineHeight: '1.5'
                                                }}
                                            />
                                        </>
                                    ) ) : (
                                        // <div className="d-flex">
                                        <>
                                            <li
                                                className="nav-item"
                                                style={{ marginRight: "20px" }}
                                                onClick={() => {
                                                    if (!user && recordingStart) {
                                                        handleSaveAudioRecording("isLogin");
                                                        // setIsLoginCancel(false)
                                                        // setBtnToggl(true)
                                                    } else {
                                                        // isDesktop ? loginOpenModal() : scrollToSection();
                                                        loginOpenModal();
                                                    }
                                                }}                                            >
                                                {/* <Button btnText={"Log in"} /> */}
                                                <button
                                                    className="login-button"
                                                >
                                                    Log in
                                                </button>
                                            </li>
                                            {/* <span className="signup-btn"></span> */}
                                            <li
                                                className="nav-item signup-btn"
                                                onClick={() => {
                                                    // navigate('/pricing')
                                                    // loginOpenModal()
                                                    if (!user && recordingStart) {
                                                        handleSaveAudioRecording("isSignup")
                                                        setAlertModal(true)
                                                        setEventClick("isSignUp")
                                                    } else {
                                                        // isDesktop ? signUpOpenModal() : scrollToSection()
                                                        signUpOpenModal()
                                                    }
                                                }}

                                            // style={{ display: "flex", backgroundColor: "#334155", alignItems: "center", borderRadius: "8px" }}
                                            >
                                                <button
                                                    className="signUp-button signup-btn"
                                                >
                                                    <span style={{ marginRight: '10px' }}>

                                                        Get Started for Free
                                                    </span>
                                                    <img
                                                        src="/img/button/arrow.png"
                                                        alt="downarrow"
                                                        height="16"
                                                        width="14"
                                                        style={{ marginRight: "4px" }}
                                                    />

                                                </button>
                                            </li>

                                        </>
                                        // </div>
                                    )}
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div >
            </div >
            {openModal && (
                <Modal onClose={() => handleClose()} modaltxt={"Settings"}>
                    <ul style={{ margin: "0px", padding: "0px" }}>
                        <li
                            className="d-flex align-items-center justify-content-between"
                            style={{
                                padding: "20px 10px",
                                borderBottom: "1px solid #E2E8F0",
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <img
                                    src="/img/icon/Defaultaudioformat.png"
                                    width="24px"
                                    height="24px"
                                    className="me-2"
                                />
                                <a
                                    className="dropdown-item"
                                    style={{
                                        fontFamily: "Metropolis",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "#000000",
                                    }}
                                >
                                    Default Audio Format
                                </a>
                            </div>

                            <div className="dropdown" >
                                <a
                                    className="dropdown-toggle custom-dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ color: "#94A3B8", textDecoration: "none" }}
                                    id="audioformat"

                                >

                                    {selectedFormat}
                                </a>

                                <div className="dropdown-menu p-3" style={{ width: '200px', borderRadius: '8px' }} ref={dropdownRef}>
                                    <div style={{
                                        padding: "10px 0px 10px 0px",
                                        borderBottom: "1px solid #F1F5F9",
                                        color: '#64748B',
                                        cursor: 'pointer'
                                    }}
                                        onClick={(e) => {
                                            handleFormatChange("mp3", e);
                                        }}
                                    >
                                        <div
                                            className="form-check d-flex justify-content-between align-items-center"
                                            style={{
                                                paddingLeft: '0px', cursor: 'pointer'
                                            }}
                                        >
                                            <label className="form-check-label" htmlFor="mp3Radio"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                mp3
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="audioFormat"
                                                id="mp3Radio"
                                                value="mp3"
                                                checked={selectedFormat === "mp3"}
                                                readOnly
                                                style={{ cursor: 'pointer' }}

                                            />
                                        </div>
                                    </div>
                                    <div style={{
                                        padding: "10px 0px 10px 0px",
                                        borderBottom: "1px solid #F1F5F9",
                                        color: '#64748B',
                                        cursor: 'pointer'


                                    }}
                                        onClick={(e) => {
                                            handleFormatChange("m4a", e);
                                        }}>
                                        <div
                                            className="form-check d-flex justify-content-between align-items-center"
                                            style={{
                                                paddingLeft: '0px',
                                                cursor: 'pointer'
                                            }}

                                        >
                                            <label className="form-check-label" htmlFor="m4aRadio"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                m4a
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="audioFormat"
                                                id="m4aRadio"
                                                value="m4a"
                                                checked={selectedFormat === "m4a"}
                                                style={{ cursor: 'pointer' }}

                                            />
                                        </div>
                                    </div>
                                    <div style={{
                                        padding: "10px 0px 10px 0px",
                                        borderBottom: "1px solid #F1F5F9",
                                        color: '#64748B',
                                        cursor: 'pointer'


                                    }}
                                        onClick={(e) => {
                                            handleFormatChange("wav", e);
                                        }}>
                                        <div
                                            className="form-check d-flex justify-content-between align-items-center"
                                            style={{
                                                paddingLeft: '0px',
                                                cursor: 'pointer'
                                            }}

                                        >
                                            <label className="form-check-label" htmlFor="wavRadio"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                wav
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="audioFormat"
                                                id="wavRadio"
                                                value="wav"
                                                checked={selectedFormat === "wav"}
                                                style={{ cursor: 'pointer' }}


                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li
                            className="d-flex align-items-center justify-content-between"
                            style={{
                                padding: "20px 10px",
                                borderBottom: "1px solid #E2E8F0",
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <img
                                    src="/img/icon/Recordingquality.png"
                                    width="24px"
                                    height="24px"
                                    className="me-2"
                                />
                                <a
                                    className="dropdown-item"
                                    style={{
                                        fontFamily: "Metropolis",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "#000000",
                                    }}
                                >
                                    Recording Quality
                                </a>
                            </div>

                            <div className="dropdown">
                                <a
                                    className="dropdown-toggle custom-dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ color: "#94A3B8", textDecoration: "none" }}
                                >
                                    {selectedQuality}
                                </a>
                                <div className="dropdown-menu p-3" style={{ width: '200px', borderRadius: '8px' }} ref={dropdownRefQuality}>
                                    <div style={{
                                        padding: "10px 0px 10px 0px",
                                        borderBottom: "1px solid #F1F5F9",
                                        color: '#64748B',
                                        cursor: 'pointer'
                                    }}
                                        onClick={(e) => handleQualityChange('High', e)}>
                                        <div
                                            className="form-check d-flex justify-content-between align-items-center "
                                            style={{
                                                paddingLeft: '0px',
                                                cursor: 'pointer'


                                            }}
                                        >
                                            <label className="form-check-label" htmlFor="highRadio" style={{ cursor: 'pointer' }}>
                                                High
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="audioQuality"
                                                id="highRadio"
                                                value="High"
                                                checked={selectedQuality === "High"}
                                                // onChange={handleQualityChange}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    <div style={{
                                        padding: "10px 0px 10px 0px",
                                        borderBottom: "1px solid #F1F5F9",
                                        color: '#64748B',
                                        cursor: 'pointer'
                                    }}
                                        onClick={(e) => handleQualityChange('Low', e)}>
                                        <div
                                            className="form-check d-flex justify-content-between align-items-center"
                                            style={{
                                                paddingLeft: '0px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <label className="form-check-label" htmlFor="lowRadio" style={{ cursor: 'pointer' }}>
                                                Low
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="audioQuality"
                                                id="lowRadio"
                                                value="Low"
                                                checked={selectedQuality === "Low"}
                                                // onChange={handleQualityChange}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </li>
                        <li
                            className="d-flex align-items-center justify-content-between"
                            style={{
                                padding: "20px 10px",
                                borderBottom: "1px solid #E2E8F0",
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <img
                                    src="/img/icon/Support.png"
                                    width="24px"
                                    height="24px"
                                    className="me-2"
                                />
                                <a
                                    className="dropdown-item"
                                    onClick={() => {
                                        navigate("/support");
                                        handleClose();
                                    }}
                                    style={{
                                        fontFamily: "Metropolis",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "#000000",
                                        cursor: "pointer",
                                    }}
                                >
                                    Support
                                </a>
                            </div>

                            <div></div>
                        </li>
                    </ul>
                </Modal >
            )}

            {
                signUpModalOpen && (
                    <CreateAccountModal
                        closeModal={signUpCloseModal}
                        openModal={loginOpenModal}
                    />
                )
            }
            {
                loginModalOpen && (
                    <LoginModal closeModal={loginCloseModal} openModal={signUpOpenModal} />
                )
            }
            {
                openChangePasswordModal && (
                    <Modal onClose={() => { setOpenChangePasswordModal(false); reset() }} modaltxt={"Change Password"}>
                        <div>
                            <div className=" d-flex justify-content-center text-center" style={{ padding: '44px 0px' }}>
                                <form onSubmit={handleSubmit(onsubmit)}
                                    noValidate
                                >
                                    <div className="row justify-content-between text-left">
                                        <div className="form-group col-sm-12 col-md-12 flex-column d-flex m-2">
                                            <input type="password" id="oldPassword" name="oldPassword" placeholder="Enter your oldPassword"
                                                className={`form-control custom-input-field ${errors.oldPassword ? 'error' : ''}`}
                                                style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                                {...register("oldPassword", {
                                                    required: 'This field is required',
                                                    minLength: {
                                                        value: 6,
                                                        message: 'Password must be between 6 and 12 characters',
                                                    },
                                                    maxLength: {
                                                        value: 12,
                                                        message: 'Password must be between 6 and 12 characters',
                                                    },
                                                })} />
                                            {errors.oldPassword && <span className="error-message">{errors.oldPassword.message}</span>}
                                        </div>
                                        <div className="form-group col-sm-12 col-md-12 flex-column d-flex m-2">
                                            <input type="password" id="newPassword" name="newPassword" placeholder="Enter your newPassword"
                                                // className="form-control input-field"
                                                className={`form-control custom-input-field ${errors.newPassword ? 'error' : ''}`}

                                                style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                                {...register("newPassword", {
                                                    required: 'This field is required',
                                                    minLength: {
                                                        value: 6,
                                                        message: 'Password must be between 6 and 12 characters',
                                                    },
                                                    maxLength: {
                                                        value: 12,
                                                        message: 'Password must be between 6 and 12 characters',
                                                    },
                                                    validate: (value) => {
                                                        if (value === watch('oldPassword')) {
                                                            return 'New password cannot be the same as the old password';
                                                        }
                                                        return true;
                                                    },
                                                })}
                                            />
                                            {errors.newPassword && <span className="error-message">{errors.newPassword.message}</span>}
                                        </div>
                                        <div className="form-group col-sm-12 col-md-12 flex-column d-flex m-2">
                                            <input type="password" id="confirmPassword" name="confirmPassword" placeholder="Enter your confirmPassword"
                                                // className="form-control input-field"
                                                className={`form-control custom-input-field ${errors.confirmPassword ? 'error' : ''}`}

                                                style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                                {...register("confirmPassword", {
                                                    required: 'This field is required',
                                                    minLength: {
                                                        value: 6,
                                                        message: 'Password must be between 6 and 12 characters',
                                                    },
                                                    maxLength: {
                                                        value: 12,
                                                        message: 'Password must be between 6 and 12 characters',
                                                    },
                                                    validate: (value) => {
                                                        if (value !== watch('newPassword')) {
                                                            return 'Passwords do not match with new password';
                                                        }
                                                        return true;
                                                    },
                                                })}
                                            />
                                            {errors.confirmPassword && <span className="error-message">{errors.confirmPassword.message}</span>}
                                        </div>

                                    </div>

                                    <div className="row justify-content-center my-4">
                                        <div className="form-group col-sm-6">
                                            <button type='submit'
                                                style={{ width: '203px', height: '54px', border: 'none', borderRadius: '8px', background: '#334155', color: 'white', cursor: loading ? 'not-allowed' : 'pointer' }}
                                                disabled={loading}>
                                                {loading ? (
                                                    <>
                                                        <div
                                                            className="spinner-border"
                                                            role="status"
                                                            style={{ width: "1.5rem", height: "1.5rem" }}
                                                        >
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <span style={{ fontFamily: 'Metropolis', fontWeight: '700', font: '16px', lineHeight: '20px', }}>Submit</span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >
                )
            }
            {
                openForgotPasswordModal && (
                    <ForgotPassword />
                )
            }
            {
                openOtpModal && (
                    <Modal
                        onClose={(e) => {
                            setOpenOtpModal(false);
                        }}
                        modaltxt={"Verify OTP"}
                    >
                        <div>
                            <div className="form-group mt-4 mb-4">
                                <p>A verification OTP has been sent to <span style={{ color: "blue" }}>{registerUserEmail}</span>.Please check your mailbox to verify the account before you start using the services.</p>
                            </div>
                            <div className="form-group mt-4 mb-4">
                                <OTPInput length={6} onOtpChange={setOtpValue} clearOtp={clearOtp} />
                            </div>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px',
                                cursor: countdown > 0 ? 'not-allowed' : 'pointer',
                                color: countdown > 0 ? 'gray' : 'blue',
                            }}
                                onClick={() => {
                                    if (countdown === 0 && !load) {
                                        handleResendOtp();
                                        setOtpValue('');
                                    }

                                }}
                            >
                                <a>{countdown > 0 ? `Resend OTP in 00:${countdown < 10 ? `0${countdown}` : countdown}` : load ? ' OTP Sending...' : 'Resend OTP'}</a>
                            </div>
                            <div className="form-group" style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', margin: '2px' }}>
                                <button
                                    type="submit"
                                    className="btn-submit"
                                    onClick={() => handleOtpSubmit()}
                                    disabled={otpValue.length < 6 || loading}
                                    style={{
                                        cursor: otpValue.length < 6 || loading ? "not-allowed" : "pointer",
                                    }}
                                >

                                    {loading ? (
                                        <>
                                            <span style={{ marginRight: '10px' }}>Saving</span>
                                            <div
                                                className="spinner-border spinner-login"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Submit
                                            </span>
                                        </>
                                    )
                                    }
                                </button>
                            </div>
                        </div>
                    </Modal >
                )
            }



            {
                alertModal && (
                    <Modal
                        onClose={() => setAlertModal(false)}
                        modaltxt={"Voice Recorder"}
                        style={{ width: '1000px' }}

                    >
                        <div onClick={(e) => e.stopPropagation()}>
                            <div className="form-group mb-4">
                                <p>Proceeding with this action may result in the loss of the current audio recording. To preserve your recording, please select "Download & Proceed." Alternatively, click "Discard" to continue without saving.</p>
                            </div>

                            <div className="form-group" style={{ display: 'flex', gap: '10px', margin: '2px' }}>
                                {/* Continue Signup (Discard Recording) */}
                                {/* <button
                                    type="button"
                                    className="btn p-3"
                                    style={{
                                        width: "100%",
                                        borderRadius: "8px",
                                        background: "red",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#FFFFFF",
                                    }}
                                    onClick={() => {
                                        setAlertModal(false);
                                        if (eventClick == "isSignUp") {

                                            setSignUpModalOpen(true); // Assuming you have a state for signup modal
                                        } else if (eventClick == "isPricing") {
                                            navigate('/pricing')
                                        }
                                        setRecordingStart(false);
                                        setIsLoginCancel(false);
                                        setBtnToggl(false);
                                        setElapsedTime(0)

                                    }}
                                >
                                    <span>Discard</span>
                                   
                                </button> */}

                                {/* Download Recording */}
                                <button
                                    type="button"
                                    className="btn p-3"
                                    style={{
                                        width: "100%",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        border: "none",
                                        background: "#334155",
                                        borderRadius: "8px",
                                        padding: "14px 20px",
                                        cursor: "pointer",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={() => {
                                        // 1. Trigger download
                                        handleDownloadClick(); // Implement this logic
                                        // 2. Close alert modal (optional, based on your flow)
                                        setAlertModal(false);
                                        if (eventClick == "isSignUp") {

                                            setSignUpModalOpen(true); // Assuming you have a state for signup modal
                                        } else if (eventClick == "isPricing") {
                                            navigate('/pricing')
                                        }
                                        setRecordingStart(false);
                                        setIsLoginCancel(false);
                                        setBtnToggl(false);
                                        setElapsedTime(0)
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <span style={{ marginRight: '10px' }}>Saving</span>
                                            <div className="spinner-border spinner-login" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <span style={{ fontWeight: "bold" }}>
                                            <img
                                                src={"/img/dashboard/download.png"}
                                                alt={"download"}
                                                style={{ marginRight: "10px" }}
                                            />
                                            Download & Proceed
                                        </span>)}
                                </button>
                                <a
                                    className="form-group"
                                    style={{
                                        color: "red",
                                        cursor: 'pointer',
                                        display: "flex",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        marginTop: '10px',
                                    }}
                                    onClick={() => {
                                        setAlertModal(false);
                                        if (eventClick == "isSignUp") {

                                            setSignUpModalOpen(true); // Assuming you have a state for signup modal
                                        } else if (eventClick == "isPricing") {
                                            navigate('/pricing')
                                        }
                                        setRecordingStart(false);
                                        setIsLoginCancel(false);
                                        setBtnToggl(false);
                                        setElapsedTime(0)

                                    }}
                                >
                                    <span>Discard</span>
                                </a>
                            </div>
                        </div>
                    </Modal>
                )
            }

        </>
    );
};

export default Navbar;
